import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import { PATH_ROUTES } from 'routes/path';
import { cn } from 'lib/utils';
import useAuthStore from 'store/auth';
import HealthInfo from './HealthInfo';
import useDashboardQuestionnaire from 'hooks/useDashboardQuestionnaire';

export default function WelcomeProfile({
  className,
  isQuestionnaireUpdated,
}: {
  className?: string;
  isQuestionnaireUpdated?: boolean;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const userAttributes = useAuthStore((store) => store.userAttributes);

  const { hasDisabled, onHideQuestionnaire } = useDashboardQuestionnaire();

  return (
    <div
      className={cn(
        'h-full rounded-xl bg-[#FFFFFF4D] mt-2 flex flex-col items-center justify-between py-6 text-white px-3',
        !isQuestionnaireUpdated && 'min-h-[calc(100vh-23rem)]',
        className
      )}
    >
      <h1 className='text-lg font-semibold'>
        {t('welcome')}, {userAttributes?.given_name}
      </h1>
      {isQuestionnaireUpdated || hasDisabled ? (
        <>
          <HealthInfo />

          <div />
        </>
      ) : (
        <>
          <p className='mb-4 leading-none text-center'>
            {t('unlock_personalised_experience')}
          </p>
          <div className='flex flex-col items-center gap-y-2'>
            <Button
              className='h-8 text-sm bg-primary-dark w-fit hover:bg-primary-dark'
              onClick={() => navigate(PATH_ROUTES.PROFILE)}
            >
              {t('add_profile_details')}
            </Button>
            <Button
              className='text-sm h-7 w-fit bg-[#FFFFFF52]'
              onClick={onHideQuestionnaire}
            >
              {t('later')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
